export const commaSeparatedToArr = (string: string) => string.split(',');
